<template>
    <div
        endpage
        data-layout-type="regular"
        :data-layout-width="layout.LayoutWidth"
        :data-reason-endpage="reasonForEndpage"
        aria-live="off"
    >
        <header data-header :data-position="layout.HeaderAlignmentPublicName">
            <div data-header-logo>
                <media
                    v-if="layout && layout.LogoImagePath"
                    data-logo
                    :url="state.layout.LogoImagePath"
                    alt="Layout Logo"
                    aria-hidden="true"
                    type="Image"
                    id="logo-image"
                />
            </div>
            <div data-header-image>
                <media
                    v-if="layout.HeaderImagePath"
                    :url="state.layout.HeaderImagePath"
                    alt="Layout Logo"
                    aria-hidden="true"
                    type="Image"
                />
            </div>
        </header>
        <main>
            <div data-main :data-no-top-border-radius="layout && layout.HeaderImagePath !== `` && layout.HeaderImagePath !== null  ? `` : null">
                <div data-complete-icon>
                    <font-awesome-icon icon="check" aria-hidden="true" />
                </div>
                <div data-content>
                    <strong
                        data-final-text
                        id="final-text"
                        v-html="DOMPurify.sanitize(message)"
                        :data-text-position="layout.TextAlignmentPublicName"
                    ></strong>
                </div>
            </div>
        </main>
        <footer v-if="layout.RemovePoweredBy !== true" data-crowdtech-logo>
         <a :href="state.surveyInfo.culture === `nl-NL` ? `https://crowdtech.com/nl/over-crowdtech/pbc/` : `https://crowdtech.com/about-crowdtech/pbc/`" target="_blank">
                <media
                    :url="`${state.settings.assetPath}powered-by-crowdtech-logo-${constrastCheck}.svg`"
                    alt="Crowdtech logo"
                    type="Image"
                />
            </a>
        </footer>
    </div>
</template>

<script>
import media from "@/components/Media.vue";
import Vue from "vue";
import VueSanitize from "vue-sanitize";
import store from "@/store/store";
import methods from "@/global/methods.js";

Vue.use(VueSanitize, store.state.global.allowedHtml);

export default {
    name: `endpage-view`,
    inject: ['DOMPurify'],
    components: {
        media,
    },
    computed: {
        message: function () {
            return this.$route.params.message || this.$store.getters.textResource("rs_end_message");
        },
        state: function () {
            return this.$store.state;
        },
        reasonForEndpage: function () {
            return this.$route.params.reasonForEndpage || ``;
        },
        layout: function () {
            return this.state.layout;
        },
        constrastCheck: function () {
            return methods.hexToRgb(this.layout.BackgroundColor);
        },
    },
    created() {
        this.$store.commit(`changeGlobal`, {
            variableName: `showLoader`,
            newValue: false,
        });
    },
};
</script>

<style scoped>
[data-content] {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;

    strong {
        font-size: calc(var(--QuestionStyling-font-size) * 1px);
        color: var(--QuestionStyling-color);
        font-family: var(--QuestionStyling-font-family-public-name);
        margin-top: 5px;
    }

    
    h2 {
        margin-bottom: 0;
        text-align: center;
        font-size: 18px;
    }

    [data-final-text] {
        &[data-text-position="Left"] {
            text-align: left;
        }

        &[data-text-position="Right"] {
            text-align: right;
        }

        &[data-text-position="Center"] {
            text-align: center;
        }
    }
}

[data-main] {
    [data-complete-icon] {
        background: #2E7D32;
        font-size: 37px;
        width: 70px;
        height: 70px;
        position: absolute;
        left: calc(50% - 35px);
        top: -40px;
        border-radius: 50%;
        box-shadow: 0 2px 3px rgba(0, 0, 0, 0.25);
        display: flex;
        justify-content: center;
        align-items: center;

        svg {
            color: #fff;
            padding-top: 4px;
        }
    }
}

[data-reason-endpage="QuotaReached"],
[data-reason-endpage="Ended"],
[data-reason-endpage="InvalidLogin"] {
    [data-complete-icon] {
        display: none;
    }

    [data-complete-text] {
        display: none;
    }

    strong {
        margin: 0;
        font-weight: bold;
        font-size: 14px;
    }
}
</style>